export function setRelatedCategories({ state, action }) {
  return {
    ...state,
    relatedSearch: {
      isConverted: action.isConverted,
      categories: action.categories,
      position: 0,
    },
  };
}

export function setRelatedSearchProducts({ state, action }) {
  return {
    ...state,
    relatedSearch: {
      isConverted: action.isConverted,
      products: action.products,
      position: 0,
    },
  };
}
